import React, { useEffect, useRef, useState } from "react";
import FlowBalls from "./FlowBalls";
import WorkflowSteps from "./WorkflowSteps";
import "../aseets/css/Workflow.css";

import './Offerings.js';
import Offerings from "./Offerings.js";
import GmTestimonials from "./GmTestimonials.js";

export default function WorkflowSection() {
    const pathRef = useRef(null);
    const sectionRef = useRef(null);
    const [progress, setProgress] = useState(0);
    const [theme, setTheme] = useState("light");

    useEffect(() => {
        const onScroll = () => {
            if (!sectionRef.current) return;

            const rect = sectionRef.current.getBoundingClientRect();
            const vh = window.innerHeight;

            // Scroll start & end points
            const start = vh * 0.2;
            const end = rect.height - vh * 0.5;

            const rawProgress = (start - rect.top) / end;
            const clampedProgress = Math.min(Math.max(rawProgress, 0), 1);

            setProgress(clampedProgress);

            // Theme switch
            if (rect.top < vh * 0.3) setTheme("workflow");
            else setTheme("light");
        };

        window.addEventListener("scroll", onScroll);
        onScroll(); // run once on mount

        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (

        <>


            {/* ======================
                WORKFLOW HEADING
            ====================== */}
            <div className="wf-header">
                <h2 className="wf-title">
                    We Always Follow The <br />
                    <span>Standard Work Process</span>
                </h2>

                <p className="wf-subtitle">
                    We solve clients’ projects in a simple & efficient way
                </p>
            </div>

            <section
                ref={sectionRef}
                className={`wf-section ${theme === "workflow" ? "wf-dark" : ""}`}
            >


                {/* ======================
                SVG PATH
            ====================== */}
                <svg
                    className="wf-svg"
                    viewBox="0 0 1200 1600"
                    preserveAspectRatio="none"
                >
                    <path
                        ref={pathRef}
                        d="
                        M200 100
                        C600 200, 600 400, 1000 500
                        C600 650, 600 850, 200 1000
                        C600 1150, 600 1350, 1000 1500
                    "
                        className="wf-path"
                        pathLength="1"
                        style={{
                            strokeDashoffset: 1 - progress,
                        }}
                    />
                </svg>

                {/* ======================
                BALLS + STEPS
            ====================== */}
                <FlowBalls
                    pathRef={pathRef}
                    progress={progress}
                    theme={theme}
                />

                <WorkflowSteps progress={progress} />
            </section>



            <Offerings />
            <GmTestimonials />




        </>

    );
}
